<h2 i18n>Email Form</h2>
<form (ngSubmit)="next()">
    @if (error) {
    <div class="alert alert-danger" role="alert">
        {{error}}
    </div>
    }
    <p i18n>
        Thank you for contributing to the Data Donation project.
    </p>

    <div class="alert alert-warning" i18n>
        To complete your submission, please enter your email address and follow each step. Note: if you close or reload the browser window your progress will not be saved.
    </div>

    <p i18n>Please provide your email address.</p>

    <ell-survey-question i18n-question question="Email address" type="email-field" [(answer)]="answers['contactEmail']"
        name="contactEmail" />

    @if (showConfirmationBox) {
        <div class="alert alert-warning">
            <p i18n>
                We have sent a confirmation code to the email address you supplied. Please check your email and enter the confirmation code provided. You will only need to do this once. If you do not see an email, please check your spam folder for an email from noreply&#64;uu.nl.
            </p>
            <form (ngSubmit)="confirmEmail()">
                <div class="input-group">
                    <input name="confirmation-code" type="text" inputmode="numeric" pattern="[0-9]*" maxlength="4" class="form-control" [(ngModel)]="confirmationCode">
                    <input type="submit" class="btn btn-primary" value="Confirm" i18n-value />
                </div>
            </form>
        </div>
    }

    <p i18n>
        Please note: the contact details which you provide for yourself count as "personal data" and are covered by the
        relevant legislation. Please see the <a [routerLink]="['/', 'privacy']" target="_blank">Privacy Statement</a>
        for details.
    </p>

    <input type="submit" class="btn btn-primary" value="Next" i18n-value />
</form>
